import { createContext } from "react";

const AccessTokenContext = createContext<string | null>(null);

export default AccessTokenContext;
